var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInnoqinline = function SvgInnoqinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112,
    height: 40,
    fill: "none",
    viewBox: "0 0 112 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#innoq_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#004153",
    d: "M0 6.997h6.222v26.057H0V6.997ZM51.22 33.054V6.997H45V22.93L33.053 6.997H27.08V22.93L15.184 6.997H9.21v26.057h6.222V17.172l11.896 15.882h6.023V17.172l11.896 15.882h5.973M67.15 12.457c4.232 0 7.268 3.077 7.268 7.544s-3.036 7.544-7.267 7.544c-4.28 0-7.267-3.077-7.267-7.544s3.036-7.544 7.267-7.544m0-5.956c-8.063 0-13.787 5.757-13.787 13.5s5.724 13.5 13.788 13.5c8.063 0 13.788-5.757 13.788-13.5s-5.725-13.5-13.788-13.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9C66",
    d: "M96.471 12.457c4.231 0 7.267 3.077 7.267 7.544 0 .844-.099 1.638-.298 2.382l-.847-1.141h-6.769l4.131 5.509a7.771 7.771 0 0 1-3.434.794c-4.23 0-7.267-3.077-7.267-7.544-.05-4.417 2.986-7.544 7.217-7.544m0-5.956c-8.063 0-13.787 5.757-13.787 13.5s5.724 13.5 13.787 13.5c2.738 0 5.077-.744 7.068-2.035l1.145 1.539h7.317l-4.131-5.56c1.443-2.084 2.289-4.516 2.289-7.444.1-7.743-5.624-13.5-13.688-13.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "innoq_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .001h112v40H0z"
  })))));
};
export default SvgInnoqinline;